import React, { Component } from "react";
import axios from "axios";
import KCLogo from "../../assets/KCLogo.gif";

class Header extends Component {
  constructor() {
    super();
    this.handleLogOff = this.handleLogOff.bind(this);
  }
  handleLogOff() {
    axios.get("/logoff").then(() => {
      window.location.href="https://login.kingcounty.gov";
    });
  }
  render() {
    let logOffButton;
    if (this.props.authorized) {
      logOffButton = (
        <button className="logOffButton" type="button" onClick={this.handleLogOff}>Log off</button>
      );
    }
    return (
      <div className="header">
        <div className="header-left">
          <div className="logoBlock">
            <a href="https://kingcounty.gov" alt="King County Logo">
              <img className="logoBlock__image" src={KCLogo} />
            </a>
          </div>
          <div className="titleBlock">
            <span className="titleBlock__text">Search Warrant Resource Center</span>
          </div>
        </div>
        <div className="header-right">
          {logOffButton}
        </div>
      </div>
    );
  }
}
 

export default Header;
